export const parseFrappeDateTime = (value) => {
    if (!value) return NaN;
    const text = String(value).trim();
    if (!text) return NaN;
    const isoLike = text.includes(" ") ? text.replace(" ", "T") : text;
    return Date.parse(isoLike);
};

const formatDuration = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
        return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
            2,
            "0"
        )}:${String(seconds).padStart(2, "0")}`;
    }

    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
        2,
        "0"
    )}`;
};

export const getAlertRemaining = (alertTime, nowMs = Date.now()) => {
    const targetMs = parseFrappeDateTime(alertTime);
    if (!Number.isFinite(targetMs)) {
        return {
            dueMs: null,
            isDue: false,
            label: "",
        };
    }

    const dueMs = targetMs - nowMs;
    const totalSeconds = Math.floor(Math.abs(dueMs) / 1000);
    const label = `${dueMs < 0 ? "-" : ""}${formatDuration(totalSeconds)}`;

    return {
        dueMs,
        isDue: dueMs <= 0,
        label,
    };
};
